import { useQuery } from "react-query";
import { getPotentialMatches } from "components/duplicate-staging/lib/productData";

export const useGetPotentialMatches = (taskContextKey) => {
    return useQuery({
        queryKey: ["potential-matches"],
        queryFn: () => getPotentialMatches(taskContextKey),
    });
};
